import {isSubjectwiseInstance} from 'common/HelperFunctions'
import {GENERAL_ENABLE_DISABLE} from 'common/constants'
import store from 'setup/redux/Store'

import {AttendanceDisplayMode} from './attendanceWizardTypes'

export function resolveAttendanceDisplayMode(): AttendanceDisplayMode {
  const generalSettings = store.getState()?.mainReducer?.generalSettings ?? {}
  const subjectAttendanceEnabled =
    Number(generalSettings.subject_attendance) === GENERAL_ENABLE_DISABLE.ENABLE

  if (isSubjectwiseInstance() && subjectAttendanceEnabled) {
    return 'subject'
  }

  return 'day'
}

export function normalizeAttendanceMode(
  value: unknown,
  fallback: AttendanceDisplayMode = resolveAttendanceDisplayMode()
): AttendanceDisplayMode {
  const raw = String(value ?? '')
    .trim()
    .toLowerCase()
  if (raw === 'subject' || raw === 'subjectwise' || raw === 'subject-wise') {
    return 'subject'
  }
  if (raw === 'day' || raw === 'daywise' || raw === 'day-wise' || raw === 'classwise') {
    return 'day'
  }
  return fallback
}

export function getAttendanceModeLabelId(mode: AttendanceDisplayMode): string {
  return mode === 'subject'
    ? 'CHATBOT.ATTENDANCE.MODE_SUBJECT_LABEL'
    : 'CHATBOT.ATTENDANCE.MODE_DAY_LABEL'
}
